/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React from 'react';

/**
 * The props that are passed down to the custom component
 */
import { jsx as ___EmotionJSX } from "@emotion/react";
export var CustomComponentFilter = function CustomComponentFilter(props) {
  var CustomComponent = props.config.component;
  return ___EmotionJSX(CustomComponent, {
    query: props.query,
    onChange: props.onChange
  });
};